import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type CheckoutStep =
  | 'form'
  | 'overview'
  | 'method'
  | 'account-binding'
  | 'payment'
  | 'success';

interface CheckoutState {
  currentStep: CheckoutStep;
  setStep: (step: CheckoutStep) => void;
  goToOverview: () => void;
  goToMethod: () => void;
  goToAccountBinding: () => void;
  goToPayment: () => void;
  goToForm: () => void;
  goToSuccess: () => void;
  resetStep: () => void;
  lastSelectedPaymentId: number | null;
  lastSelectedPaymentIndex: number | null;
  setLastSelectedPayment: (id: number | null, index: number | null) => void;
  selectedPaymentKey: string | null;
  setSelectedPaymentKey: (key: string | null) => void;
  submittedCustomerNo: string | null;
  setSubmittedCustomerNo: (customerNo: string | null) => void;
}

export const useCheckoutStore = create<CheckoutState>()(
  persist(
    (set) => ({
      currentStep: 'form',
      setStep: (step) => set({ currentStep: step }),
      goToOverview: () => set({ currentStep: 'overview' }),
      goToMethod: () => set({ currentStep: 'method' }),
      goToAccountBinding: () => set({ currentStep: 'account-binding' }),
      goToPayment: () => set({ currentStep: 'payment' }),
      goToForm: () => set({ currentStep: 'form' }),
      goToSuccess: () => set({ currentStep: 'success' }),
      resetStep: () => set({ currentStep: 'form' }),
      lastSelectedPaymentId: null,
      lastSelectedPaymentIndex: null,
      setLastSelectedPayment: (id, index) =>
        set({ lastSelectedPaymentId: id, lastSelectedPaymentIndex: index }),
      selectedPaymentKey: null,
      setSelectedPaymentKey: (key) => set({ selectedPaymentKey: key }),
      submittedCustomerNo: null,
      setSubmittedCustomerNo: (customerNo) =>
        set({ submittedCustomerNo: customerNo }),
    }),
    {
      name: 'checkout-step-storage',
    }
  )
);
